<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
        <div class="row p-0 align-items-center rental-payment assign-payment-btn">
  <div class="col-12 col-md-auto add-btn mb-lg-1 mb-md-1 d-flex justify-content-center">
    <llp-button
      :load-spinner="showaddUserSpinner"
      :classNames="viewMode === 'assign'
        ? 'btn-secondary new-btn d-none d-md-block'
        : 'btn-primary new-btn d-none d-md-block'"
      type="button"
      @click:button="viewMode = 'assign'"
    >
      Assigned Group Charges
    </llp-button>
    <llp-button
      :classNames="viewMode === 'assign'
        ? 'btn-secondary new-btn d-block d-md-none w-100'
        : 'btn-primary new-btn d-block d-md-none w-100'"
      type="button"
      @click:button="viewMode = 'assign'"
    >
      Assigned Group Charges
    </llp-button>
  </div>

  <div class="col-12 col-md-auto add-btn mb-lg-1 mb-md-1 ms-md-2 d-flex justify-content-center">
    <llp-button
      :classNames="viewMode === 'unassign'
        ? 'btn-secondary new-btn d-none d-md-block'
        : 'btn-primary new-btn d-none d-md-block'"
      type="button"
      @click:button="viewMode = 'unassign'"
    >
      Unassigned Group Charges
    </llp-button>
    <llp-button
      :classNames="viewMode === 'unassign'
        ? 'btn-secondary new-btn d-block d-md-none w-100'
        : 'btn-primary new-btn d-block d-md-none w-100'"
      type="button"
      @click:button="viewMode = 'unassign'"
    >
      Unassigned Group Charges
    </llp-button>
  </div>

  <div class="col-12 col-md-auto ms-md-auto add-btn mb-lg-1 mb-md-1 d-flex justify-content-center justify-content-md-end">
    <llp-button
      classNames="btn-secondary new-btn w-100 w-md-auto"
      type="button"
      @click:button="BackToGroupCharges()"
    >
      Back To Group Charges
    </llp-button>
  </div>
</div>
          </div>
        </div>
        <div class="card m-4 m-lg-3">
          <div class="card-body" v-if="viewMode === 'assign'">
            <div class="row">
              <div class="col mt-4 ms-lg-3 mb-3">
                <h4>Assign Group Charges</h4>
              </div>
            </div>
            <div class="row ms-lg-2">
              <div class="col-lg-3 col-md-4 col-sm-5">
                <llp-label id="confirmPasswordLabel"
                  >Present Group Name:</llp-label
                >
                <llp-input
                  id="confirmpassword"
                  class="w-100"
                  autocomplete="off"
                  v-model="selectedAssignGroupName"
                  disabled
                ></llp-input>
              </div>
              <div class="col-lg-3 col-md-5 col-sm-5 mt-xs-4">
                <llp-label id="role" :aria-label="Role">
                  Select Group Name:
                </llp-label>
                <select
                  id="status"
                  class="form-control select-dropdown"
                  v-model="selectGroupName"
                >
                  <option value="" disabled selected>Select group name</option>
                  <option
                    v-for="names in groupsdropdown"
                    :key="names.id"
                    :value="names.id"
                  >
                    {{ names.name }}
                  </option>
                </select>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2">
                <llp-button
                  :load-spinner="assignGroupSpinner"
                  classNames="btn-secondary text-nowrap new-btn mt-2 group-charges-btn"
                  type="button"
                  @click:button="AssignCharges()"
                >
                  Assign Group
                </llp-button>
              </div>
            </div>
            <div class="row p-4 position-relative">
              <div v-if="loading" class="loader-overlay mt-lg-2 mt-md-2 mb-sm-2 ">
                <div class="spinner"></div>
              </div>
                            <llp-datatable
                ref="assignTable"
                :columns="columns"
                :data="assignCharges"
                :lazy="true"
                :paginator="true"
                :totalRecords="assignCharges.length"
                scrollable
                @onPageChange="onPageChange"
              >
                <template #selectHeader>
                  <div class="text-center">
                    <input
                      type="checkbox"
                      :checked="allSelected"
                      @change="toggleSelectAll($event)"
                    />
                  </div>
                </template>

                <template #actions="{ data }">
                  <div class="text-center">
                    <input
                      type="checkbox"
                      v-model="data.selected"
                      @change="onUserSelectAssignUser(data)"
                    />
                  </div>
                </template>
              </llp-datatable>
            </div>
          </div>
          <div class="card-body" v-if="viewMode === 'unassign'">
            <div class="row">
              <div class="col mt-4 ms-lg-3 mb-3">
                <h4>Unassign Group Charges</h4>
              </div>
              <div class="row ms-lg-2">
                <div class="col-lg-3 col-md-6 col-sm-6">
                  <llp-label id="role" :aria-label="Role">
                    Select Group Name:
                  </llp-label>
                  <llp-input
                    id="group_name"
                    v-model="selectUnAssignGroupName"
                    disabled
                  ></llp-input>
                </div>
                <div class="col-lg-1 col-md-3 col-sm-6">
                  <llp-button
                    :load-spinner="showaddUserSpinner"
                    classNames="btn-secondary text-nowrap new-btn mt-2 group-charges-btn"
                    type="button"
                    @click:button="UnAssignCharges()"
                  >
                    Assign Group
                  </llp-button>
                </div>
              </div>
            </div>
            <div class="row p-4 position-relative">
              <div v-if="loading" class="loader-overlay mt-lg-2 mt-md-2">
                <div class="spinner"></div>
              </div>
                <llp-datatable
                ref="unassignTable"
                :columns="UnAssigncolumns"
                :data="UnassignCharges"
                :lazy="true"
                :paginator="true"
                :totalRecords="UnassignCharges.length"
                scrollable
                @onPageChange="onPageChange"
              >
                <template #selectHeader>
                  <div class="text-center">
                    <input
                      type="checkbox"
                      :checked="allUnSelected"
                      @change="toggleSelectAll($event)"
                    />
                  </div>
                </template>

                <template #actions="{ data }">
                  <div class="text-center">
                    <input
                      type="checkbox"
                      v-model="data.selected"
                      @change="onUserSelectUnAssignUser(data)"
                    />
                  </div>
                </template>
              </llp-datatable>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>
<script>
import NetworkService from "@/services/network.service";

export default {
  setup() {},
  data() {
    return {
      loading: false,
      assignGroupSpinner: false,
      columns: [
        { field: "s_no", className: "text-center", header: "S_no" },
        {
          field: "select_user",
          header: "Select User",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
          headerSlot: "selectHeader",
        },

        { field: "username", className: "text-center", header: "User Name" },
        { field: "mobile", className: "text-center", header: "Mobile" },
      ],
      UnAssigncolumns: [
        { field: "s_no", className: "text-center", header: "S_no" },
        {
          field: "select_user",
          header: "Select User",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
          headerSlot: "selectHeader",
        },

        { field: "username", className: "text-center", header: "User Name" },
        { field: "mobile", className: "text-center", header: "Mobile" },
      ],

      assignCharges: [],
      UnassignCharges: [],
      selectGroupName: "",
      selectUnAssignGroupName: "",
      selectedAssignGroupName: "",
      user_id: localStorage.getItem("User_id"),
      selected_id: this.$route.params.id,
      selected_role_id: this.$route.params.role_id,
      currentPage: 1,
      totalRecords: 0,
      perpage: 10,
      selected: "",
      allUnSelected: false,
      allSelected: false,
      viewMode: "assign",
      groupsdropdown: [],
    };
  },
  mounted() {
    if (this.viewMode === "assign") {
      this.fetchingAssignGroupCharges();
    } else if (this.viewMode === "unassign") {
      this.fetchingUnAssignGroupCharges();
    }
  },
  watch: {
    viewMode(newValue) {
      if (newValue === "assign") {
        this.fetchingAssignGroupCharges();
      } else if (newValue === "unassign") {
        this.fetchingUnAssignGroupCharges();
      }
    },
  },
  methods: {
    onPageChange(event) {
      const { first, rows } = event;
      this.currentPage = first / rows + 1;
      this.perpage = rows;
       this.loading = true;
      this.fetchingAssignGroupCharges(this.currentPage, this.perpage);
    },
    onUserSelectUnAssignUser() {
      this.allUnSelected = this.UnassignCharges.every((user) => user.selected);
    },
    onUserSelectAssignUser() {
      this.allSelected = this.assignCharges.every((user) => user.selected);
    },
 toggleSelectAll(event) {
      const isChecked = event.target.checked;
      if (this.viewMode === "assign") {
        this.assignCharges.forEach((user) => {
          user.selected = isChecked;
        });
        this.allSelected = isChecked; 
      } else if (this.viewMode === "unassign") {
        this.UnassignCharges.forEach((user) => {
          user.selected = isChecked;
        });
        this.allUnSelected = isChecked; 
      }
    },

    async fetchingAssignGroupCharges() {
      try {
        const requestData = {
          currentPage: this.currentPage,
          per_page: this.perpage,
        };
        this.loading = true;
        const chargesResponse = await NetworkService.get(
          `/get-users-for-assign-charges/${this.selected_id}/${this.selected_role_id}/${this.user_id}`,
          requestData
        );
        this.selectedAssignGroupName = chargesResponse.groupname;
        const startIndex = (this.currentPage - 1) * this.perpage;
        this.assignCharges = chargesResponse.data.map((charges, index) => {
          return {
            s_no: startIndex + index + 1,
            username: `${charges.name} (${charges.username})`,
            mobile: charges.mobile,
            selected: charges.status === 1,
            id: charges.id,
          };
        });
        this.groupsdropdown = chargesResponse.groupsdropdown;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$refs.toast.show("Unable to fetching the group charges", "error");
      }
    },
   
   
   async AssignCharges() {
      this.assignGroupSpinner = true; 
      const selectedUsers = this.assignCharges.filter((user) => user.selected);
      if (selectedUsers.length === 0) {
        this.$refs.toast.show(
          "Please select at least one user to assign.",
          "error"
        );
        this.assignGroupSpinner = false; 
        return; 
      }

  
      if (!this.selectGroupName) {
        this.$refs.toast.show(
          "Please select a group name from the dropdown.",
          "error"
        );
        this.assignGroupSpinner = false; 
        return;
      }

      try {
        const payload = {
          user_id: selectedUsers.map((user) => user.id),
          group_id: this.selectGroupName,
          id: this.selected_id,
        };
        const assignResponse = await NetworkService.post(
          `assign-users-assign-group/${this.selected_id}`,
          payload
        );
        this.assignGroupSpinner = false;
        this.$refs.toast.show(assignResponse.data.message);
       
        setTimeout(() => {
          this.fetchingAssignGroupCharges();
        }, 300);
      } catch (error) {
        this.assignGroupSpinner = false; 
        this.$refs.toast.show("Unable to assign the group charges", "error");
      }
    },
   async fetchingUnAssignGroupCharges() {
      try {
        const requestData = {
          currentPage: this.currentPage,
          per_page: this.perpage,
        };
         this.loading = true;
        const chargesResponse = await NetworkService.get(
          `/get-users-for-unassign-charges/${this.selected_id}/${this.selected_role_id}/${this.user_id}`,
          requestData
        );

        const startIndex = (this.currentPage - 1) * this.perpage;
        this.UnassignCharges = chargesResponse.data.map((charges, index) => {
          return {
            s_no: startIndex + index + 1,
            username: `${charges.username} (${charges.name})`,
            mobile: charges.mobile,
            selected: false,
            id: charges.id,
          };
        });
        this.selectUnAssignGroupName = chargesResponse.groupname;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$refs.toast.show("Unable to fetching the group charges", "error");
      }
    },
    async UnAssignCharges() {
      const selectedUsers = this.UnassignCharges.filter(
        (user) => user.selected
      );
    
      if (selectedUsers.length === 0) {
        this.$refs.toast.show(
          "Please select at least one user to unassign.",
          "error"
        );
        return;
      }
      try {
        const payload = {
          user_id: selectedUsers.map((user) => user.id),
          group_id: this.selectGroupName,
          id: this.selected_id,
        };
        const unassignResponse = await NetworkService.post(
          `assign-users-unassign-group/${this.selected_id}`,
          payload
        );
        setTimeout(() => {
          this.fetchingUnAssignGroupCharges();
        }, 3000);
        this.$refs.toast.show(unassignResponse.data.message);
      } catch (error) {
        this.$refs.toast.show("Unable to unassign the group charges", "error");
      }
    },
    BackToGroupCharges() {
      this.$router.push("/charges");
    },
  },
};
</script>
